export default __webpack_public_path__ + "static/media/2S.ec187ad2.svg";